import { ResponseDTO } from './response-dto';
import { SapUserDTO } from './sap-user-dto';

export interface ReadSapResponseDTO extends ResponseDTO {
    sapUsers?: SapUserDTO[];
}
